import { useFadeIn } from './useFadeIn';
import ReelShowcase from './ReelShowcase';

const WHY = [
  {
    title: 'Long Term Relation',
    desc: 'We create impactful and strategic plans aiming for you as our long-term partner — not just a one-off campaign.',
  },
  {
    title: 'Content Driven',
    desc: 'Creating what marks quality, completeness and providing solutions in every aspect of your content strategy.',
  },
  {
    title: 'Exclusive Strategies',
    desc: 'Using data and analytics with proper insights to suit your brand and drive its best outcomes at every stage.',
  },
  {
    title: 'A-Game Efforts',
    desc: "Making sure you get what you want — putting our best foot forward for your brand as if it were our own.",
  },
];

export default function OurWork() {
  const leftRef = useFadeIn();
  const midRef = useFadeIn();
  const rightRef = useFadeIn();

  return (
    <section id="ourwork" data-testid="why-coaching-section" className="ourwork-section">
      <div className="ourwork-inner">
        {/* Left — pull quote */}
        <div ref={leftRef} className="ourwork-left fade-up" data-testid="why-coaching-heading">
          <p className="sec-overline">Our Work</p>
          <h2 className="ourwork-pullquote">
            "Unlocking the power of influence — we connect brands and audiences with authentic storytelling that sparks lasting connections."
          </h2>
          <p className="ourwork-sub">
            With strategic partnerships and creative campaigns, we elevate brands to new heights in the digital landscape, driving meaningful engagement and measurable results.
          </p>
          <a href="#contact" className="btn-black">
            Start a Campaign
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 7h12M7 1l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>

        {/* Centre — reel showcase */}
        <div ref={midRef} className="ourwork-reels fade-up d1">
          <ReelShowcase />
        </div>

        {/* Right — Why Choose Us */}
        <div ref={rightRef} className="ourwork-right fade-up d2" data-testid="why-coaching-points">
          <p className="sec-overline">Why Choose Us?</p>
          <div className="why-list">
            {WHY.map((w, i) => (
              <div key={i} className="why-item">
                <span className="why-num">0{i + 1}</span>
                <div className="why-content">
                  <div className="why-title">{w.title}</div>
                  <p className="why-desc">{w.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
